var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNwdLogoDark = function SvgNwdLogoDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 36.697,
    viewBox: "0 0 230 36.697",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-379 -1827)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(379 1827)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.109,213.368h1.345l7.454,11.2v-11.2h1.383v13.448h-1.345l-7.454-11.123v11.123h-1.383Z",
    transform: "translate(-153.109 -213.214)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.249,226.479a1.28,1.28,0,0,1-.326-.932v-12.18h9.029V214.6h-7.608v4.726h7.031v1.23h-7.031v5.033h7.608v1.23h-7.781A1.225,1.225,0,0,1,195.249,226.479Z",
    transform: "translate(-181.668 -213.214)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.2,226.518a1.707,1.707,0,0,1-.423-.951l-2.286-12.2h1.4l2.094,11.6h.019l3.381-10.893h.6a.773.773,0,0,1,.557.2,1.462,1.462,0,0,1,.346.624l3,10.066h.019l2.094-11.6h1.4l-2.286,12.2a1.712,1.712,0,0,1-.423.951,1.165,1.165,0,0,1-.845.3h-.576l-3.266-10.835h-.019l-3.362,10.835h-.576A1.163,1.163,0,0,1,231.2,226.518Z",
    transform: "translate(-204.598 -213.214)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.108,226.518a1.707,1.707,0,0,1-.423-.951l-2.286-12.2h1.4l2.094,11.6h.019l3.381-10.893h.6a.773.773,0,0,1,.557.2,1.462,1.462,0,0,1,.346.624l3,10.066h.019l2.094-11.6h1.4l-2.286,12.2a1.711,1.711,0,0,1-.423.951,1.165,1.165,0,0,1-.845.3h-.577l-3.266-10.835h-.019l-3.362,10.835h-.576A1.163,1.163,0,0,1,298.108,226.518Z",
    transform: "translate(-250.292 -213.214)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.94,213.368h1.422v13.448H349.94Z",
    transform: "translate(-287.543 -213.214)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.727,213.368h1.345l7.454,11.2v-11.2h1.383v13.448h-1.345l-7.454-11.123v11.123h-1.383Z",
    transform: "translate(-297.643 -213.214)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.868,226.489a1.246,1.246,0,0,1-.327-.922v-12.2h5.571a5.433,5.433,0,0,1,2.5.547,4,4,0,0,1,1.671,1.556,4.466,4.466,0,0,1,.6,2.315v4.226a4.928,4.928,0,0,1-1.191,3.583,4.671,4.671,0,0,1-3.5,1.22h-4.4A1.246,1.246,0,0,1,406.868,226.489Zm5.283-.942a3.219,3.219,0,0,0,2.469-.893,3.737,3.737,0,0,0,.836-2.642v-4.226a2.979,2.979,0,0,0-.932-2.276,3.436,3.436,0,0,0-2.449-.874h-4.111v10.912Z",
    transform: "translate(-326.202 -213.214)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.326,226.043a4.081,4.081,0,0,1-1.585-1.691,5.438,5.438,0,0,1-.567-2.536V217.7a5.439,5.439,0,0,1,.567-2.536,4.082,4.082,0,0,1,1.585-1.691,4.6,4.6,0,0,1,2.363-.6h2.036a4.6,4.6,0,0,1,2.363.6,4.088,4.088,0,0,1,1.585,1.691,5.445,5.445,0,0,1,.567,2.536v4.111a5.386,5.386,0,0,1-.567,2.526,4.147,4.147,0,0,1-1.595,1.691,4.549,4.549,0,0,1-2.353.605h-2.056A4.553,4.553,0,0,1,448.326,226.043Zm4.361-.672a2.878,2.878,0,0,0,2.267-.98,3.747,3.747,0,0,0,.864-2.574V217.7a3.748,3.748,0,0,0-.864-2.574,2.879,2.879,0,0,0-2.267-.98h-1.96a2.878,2.878,0,0,0-2.267.98,3.746,3.746,0,0,0-.865,2.574v4.111a3.773,3.773,0,0,0,.855,2.574,2.848,2.848,0,0,0,2.257.98Z",
    transform: "translate(-353.271 -212.883)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.123,226.518a1.708,1.708,0,0,1-.423-.951l-2.286-12.2h1.4l2.094,11.6h.02l3.381-10.893h.6a.773.773,0,0,1,.557.2,1.461,1.461,0,0,1,.346.624l3,10.066h.019l2.094-11.6h1.4l-2.286,12.2a1.714,1.714,0,0,1-.423.951,1.165,1.165,0,0,1-.845.3h-.576l-3.266-10.835h-.019l-3.362,10.835h-.576A1.163,1.163,0,0,1,489.123,226.518Z",
    transform: "translate(-380.754 -213.214)",
    fill: "#183149"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.053 18.011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.955,286.773l-3.053,1.763H153.137V270.113H163.9l3.053,1.763Zm-11.186-14.291v13.686h8.553V272.482Z",
    transform: "translate(-153.137 -269.981)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.3,280.246v5.922h7.869v2.369h-10.5V270.113h10.5v2.369H214.3v5.4h6.29v2.369Z",
    transform: "translate(-193.113 -269.981)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.028,270.113l-6.58,18.423h-3.264l-6.58-18.423h2.658l5.527,15.712h.053l5.527-15.712Z",
    transform: "translate(-219.707 -269.981)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.176,280.246v5.922h7.869v2.369h-10.5V270.113h10.5v2.369h-7.869v5.4h6.29v2.369Z",
    transform: "translate(-261.328 -269.981)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.292,288.536V270.113h2.632v16.055h6.817v2.369Z",
    transform: "translate(-291.891 -269.981)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.877,286.621l-3.053,1.764h-7.711l-3.053-1.764v-15.16l3.053-1.763h7.711l3.053,1.763Zm-11.185-14.554v13.949h8.554V272.067Z",
    transform: "translate(-319.052 -269.698)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.59,288.536V270.113h9.186l3.053,1.763v7.817l-3.053,1.763h-6.554v7.08Zm2.632-16.055v6.606H464.2v-6.606Z",
    transform: "translate(-359.028 -269.981)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.534,288.536v-15h-.052l-5.422,15h-2.632l-5.4-15h-.052v15h-2.5V270.113h3.711l5.527,15.37h.053l5.553-15.37h3.711v18.423Z",
    transform: "translate(-394.468 -269.981)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.588,280.246v5.922h7.869v2.369h-10.5V270.113h10.5v2.369h-7.869v5.4h6.29v2.369Z",
    transform: "translate(-444.652 -269.981)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.336,274.614v13.923H624.7V270.113H627.1l9.528,13.923h.053V270.113h2.632v18.423h-2.4l-9.527-13.923Z",
    transform: "translate(-475.215 -269.981)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.614,272.482v16.055h-2.632V272.482h-5.237v-2.369h13.107v2.369Z",
    transform: "translate(-513.49 -269.981)",
    fill: "#183149"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(212.84 33.796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M746.9,319.492V321.7h-17.16v-2.211Z",
    transform: "translate(-729.742 -319.492)",
    fill: "#5680e9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.571 0.197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.32,213.5h3.441L88.833,249.873l-3.463-.022Z",
    transform: "translate(-85.37 -213.504)",
    fill: "#5680e9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.284,213.5h3.441L61.8,249.873l-3.463-.022Z",
    transform: "translate(-58.334 -213.504)",
    fill: "#5680e9"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNwdLogoDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nwd-logo-dark.9ea0cf03.svg";
export { ForwardRef as ReactComponent };